module.exports = __webpack_public_path__ + "static/media/mainImg.94cf140c.png";